"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGameReport = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var navigation_1 = require("next/navigation");
var apps_shared_1 = require("@l2p/apps-shared");
var geo_1 = require("../geo");
var user_1 = require("../user");
var useGameReport = function () {
    var _a;
    var params = (0, navigation_1.useParams)();
    var searchParams = (0, navigation_1.useSearchParams)();
    var gameId = (0, apps_shared_1.useRestoredGameId)(params === null || params === void 0 ? void 0 : params.id);
    var data = (0, geo_1.useGeo)().data;
    var isAuth = (0, user_1.useIsAuthorized)();
    var isDemo = (0, react_1.useMemo)(function () {
        var demo = searchParams.get('demo');
        return !!(demo && demo === 'true');
    }, [searchParams]);
    var _b = (0, useMutation_1.useMutation)({
        path: keys_1.GAME_REPORT,
    }), mutate = _b.mutate, isSubmitting = _b.isSubmitting, error = _b.error;
    var reportGame = (0, react_1.useCallback)(function (_a) {
        var _b;
        var errorMessage = _a.errorMessage, errorCode = _a.errorCode;
        mutate({
            errorCode: errorCode,
            errorMessage: errorMessage,
            gameId: gameId,
            brand: window.location.hostname,
            demo: isAuth ? isDemo : true,
            currentGeo: (_b = data === null || data === void 0 ? void 0 : data.geoData) === null || _b === void 0 ? void 0 : _b.countryCode,
            isAuth: isAuth,
        });
    }, [isAuth, gameId, mutate, isDemo, (_a = data === null || data === void 0 ? void 0 : data.geoData) === null || _a === void 0 ? void 0 : _a.countryCode]);
    return (0, react_1.useMemo)(function () { return ({
        reportGame: reportGame,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [reportGame, isSubmitting, error]);
};
exports.useGameReport = useGameReport;
